import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "simple-example-with-dependency",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#simple-example-with-dependency",
        "aria-label": "simple example with dependency permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Simple example with dependency`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "name": "update_user_details",
    "description": "Update user details",
    "url": "/api/v1/users/{userId}",
    "method": "PUT",
    "variables": {
        "newUserName": "{dataset.names}"
    },
    "payload": {
        "name": "{newUserName}"
    },
    "dependencies":[{
        "api": "create_a_user",
        "variable": {
            "userId": "response.id",
            "oldUserName": "response.name"
        }
    }]
}
`}</code></pre>
    <h2 {...{
      "id": "simple-example-with-assertions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#simple-example-with-assertions",
        "aria-label": "simple example with assertions permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Simple example with assertions`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "id": "f06b299a-82d0-4e27-af7f-8b46ca23d7d4",
    "app": "{appName}",
    "name": "users_crud2",
    "endpoints": [
        {
            "name": "01_get_all_users",
            "description": "List all users",
            "url": "/api/v1/users",
            "method": "GET",
            "expect": {
                "status": 200,
                "headers": {
                    "content-type": "application/json"
                },
                "response": {
                    "There should be more than 10 users": "{response.length} > 10",
                    "Atleast one user should be admin": "{response.all.isAdmin}.filter(isAdmin => isAdmin).length === 0",
                    "All users have an ID of 32 characters": "{response.all.id}.every(id => id.length === 36)"
                },
                "timing": {
                    "total": "<700",
                    "firstByte": "<300"
                }
            }
        }
    ]
}
`}</code></pre>
    <h2 {...{
      "id": "datasets-and-variables-usage",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#datasets-and-variables-usage",
        "aria-label": "datasets and variables usage permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Datasets and variables usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "id": "319ac86a-f2d7-4cb4-a7fc-5910fe0154d4",
    "app": "demo",
    "name": "users_demo",
    "endpoints": [
        {
            "name": "create_a_user",
            "description": "Create a new User",
            "url": "/api/v1/users",
            "method": "POST",
            "scripts": {
                "before-endpoint": "variables.spells = [...new Array(10)].map(() => '{dataset.spells}'); return { variables }"
            },
            "variables": {
                "userName": "{dataset.harrypotter}",
                "password": "[a-zA-Z0-9]{7,15}"
            },
            "payload": {
                "name": "{userName}",
                "country": "{dataset.countries}",
                "motto": "{lorem_5000}",
                "favorites": {
                    "spells": "{spells}",
                    "quote": "{dataset.quotes}",
                    "gameOfThronesCharacter": "{dataset.got}",
                    "marvelCharacter": "{dataset.marvel}",
                    "starWarsCharacter": "{dataset.starWars}",
                    "celestialObject": "{dataset.space}",
                    "pokemon": "{dataset.pokemon}"
                }
            },
            "expect": {
                "status": 201
            }
        }
    ]
}
`}</code></pre>
    <h2 {...{
      "id": "scripts-lifecycle",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#scripts-lifecycle",
        "aria-label": "scripts lifecycle permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Scripts lifecycle`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "id": "some unique Id",
    "app": "exampleApp",
    "name": "e_scripts_lifecycle",
    "scripts": {
        "before-scenario": "logger.log('Lifecycle Hook: before-scenario')",
        "after-scenario": "logger.log('Lifecycle Hook: after-scenario')",
        "before-each": "logger.log('Lifecycle Hook: before-each')",
        "after-each": "logger.log('Lifecycle Hook: after-each')",
        "after-globals": "logger.log('Lifecycle Hook: after-globals')"
    },
    "endpoints": [
        {
            "name": "sample_api_for_scripts",
            "description": "Sample API to show lifecycle hooks",
            "url": "/api/v1/test",
            "scripts": {
                "before-endpoint": "logger.log('Lifecycle Hook: before-endpoint')",
                "after-endpoint": "logger.log('Lifecycle Hook: after-endpoint')",
                "after-dependencies": "logger.log('Lifecycle Hook: after-dependencies')"
            }
        }
    ]
}
`}</code></pre>
    <h2 {...{
      "id": "github-api-v3-sample-tests",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#github-api-v3-sample-tests",
        "aria-label": "github api v3 sample tests permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Github API v3 sample tests`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "id": "some unique Id",
    "app": "exampleApp",
    "name": "e_github_api_v3_repos_crud",
    "endpoints": [
        {
            "name": "01_get_all_repos",
            "description": "Load all repositories that the user has access to",
            "url": "/users/{username}/repos",
            "method": "GET",
            "variables": {
                "username": "sarathm09"
            },
            "headers": {
                "User-Agent": "Vibranium"
            }
        },
        {
            "name": "02_create_a_repo",
            "description": "Create a new repository with a random name",
            "url": "/user/repos",
            "method": "POST",
            "payload": {
                "name": "{repoName}",
                "description": "{repoDescription}",
                "homepage": "https://github.com",
                "private": false,
                "has_issues": true,
                "has_projects": true,
                "has_wiki": true
            },
            "variables": {
                "repoName": "{dataset.names}",
                "repoDescription": "{dataset.quotes}"
            },
            "expect": {
                "status": 201,
                "response": {
                    "Verify that the the repo name is same": "'{response.name}' === '{repoName}'"
                }
            },
            "headers": {
                "User-Agent": "Vibranium"
            }
        },
        {
            "name": "03_delete_a_repo",
            "description": "Delete a newly created repository",
            "url": "/repos/{username}/{reponame}",
            "method": "DELETE",
            "dependencies": [
                {
                    "api": "02_create_a_repo",
                    "variable": {
                        "reponame": "name",
                        "username": "owner.login"
                    }
                }
            ],
            "expect": {
                "status": 204
            },
            "headers": {
                "User-Agent": "Vibranium"
            }
        }
    ]
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      